const organization = {
    require_membership: 'O usuário deve ser um membro da organização para continuar.',
    role_names_not_found: '检测到无效的角色名称：{{names,list(type:conjunction)}}。请先创建这些角色然后再继续操作。',
};
export default Object.freeze(organization);
